import SpeedUpIcon from './SpeedUpIcon'

export default SpeedUpIcon
